app.filter('undefined', ['$filter', function ($filter) {
    return function (v) {
        return /undefined/i.test(v);
    };
}]); //end undefined filter

app.filter('empty', ['$filter', function ($filter) {
    return function (v) {
        if (v === "" || v === null || v === "null") {
            return true;
        } else {
            return false;
        }
    };
}]); //end empty filter

app.filter('nan', ['$filter', function ($filter) {
    return function (v) {
        return isNaN(v);
    };
}]); //end nan filter
app.filter('serverDate', ['$filter', function ($filter) {//

    return function (date) {

        var dateSplit = date.split('/');
        var dateDay = dateSplit[0];
        var dateMonth = dateSplit[1];
        var dateYear = dateSplit[2];

        return dateYear + "-" + dateMonth + "-" + dateDay;
    };

}]);

app.filter('dashDate', ['$filter', function ($filter) {

    return function (date) {

        var dateSplit = date.split('/');
        var dateDay = dateSplit[0];
        var dateMonth = dateSplit[1];
        var dateYear = dateSplit[2];

        return dateDay + "-" + dateMonth + "-" + dateYear;
    };

}]);

app.filter('percentage', ['$filter', function ($filter) {

    return function (input, decimals) {
        if ($filter('undefined')(input) || $filter('empty')(input)) {
            return "";
        }
        return $filter('number')(input, decimals) + '%';
    };

}]);

app.filter('customCurrency', ["$filter", function ($filter) {

    return function (amount, currencySymbol) {
        var currency = $filter('currency');
        if (amount < 0) {
            return currency(amount, currencySymbol).replace("(", "-").replace(")", "");
        }
        return currency(amount, currencySymbol);
    };

}]);

app.filter('enstr64', ['$filter', function ($filter) {

    return function (v) {
        

        //return encodeURIComponent(v);
        //var es = btoa(v) || "";
        //TODO: Refractor to encode some special charaters

        var es = btoa(encodeURIComponent(v).replace(/%([0-9A-F]{2})/g, function (match, p1) {
            var tmp = String.fromCharCode('0x' + p1);
            return String.fromCharCode('0x' + p1);
        })) || "";
        var newstr = "";
        var c;
        for (var i = 0; i < es.length; i++) {
            c = es.charAt(i);
            newstr = newstr + c;
            if (i % 2 != 0 && (i < es.length - 1)) {
                var eChar = $filter('sessKey')(1);
                newstr = newstr + eChar;
            }
        }
        return newstr;
    };

}]); //end encodeString filter

app.filter('decstr64', ['$filter', function ($filter) {

    return function (es) {
        if ($filter('undefined')(es) || $filter('empty')(es)) {
            return null;
        }
        var es = es || "";
        var newStr = "";
        var c, string, counter, counter2;
        counter = counter2 = 0;
        for (var i = 0; i < es.length; i++) {
            counter++;
            counter2++;
            if (counter == 3) {
                string = es.substring(i - 2, i);
                newStr = newStr + string;
                counter = 0;
            } else {
                if (counter == 2 && counter2 == es.length) {
                    string = es.substring(i - 1, i + 1);
                    newStr = newStr + string;
                    counter = 0;
                }
            }
        }
        //var ds = atob(newStr);
        //TODO: Refractor to decode some special charaters
        var ds = decodeURIComponent(Array.prototype.map.call(atob(newStr), function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        return ds;
    };

}]); //end decodeString filter

app.filter('str2arr', ['$filter', function ($filter) {
    return function (value, fnParser, separator) {
        value = value || '';
        separator = separator || ',';
        var result = value.split(separator);
        if (fnParser) {
            result = jQuery.map(result, function (val, key) {
                return fnParser(val);
            });
        }
        return result;
    };
}]); //end split array of session storage

app.filter('dec2arr', ['$filter', function ($filter) {
    return function (value, fnParser, separator) {
        value = $filter('decstr64')(value) || '';
        return $filter('str2arr')(value, fnParser, separator);
    };
}]); // decode string then convert to array with optional parser

app.filter('dec2num', ['$filter', function ($filter) {
    return function (value) {
        value = $filter('decstr64')(value) || NaN;
        if (isNaN(value)) {
            return NaN;
        }
        return JSON.parse(value);
    };
}]); // decode string then convert to number

app.filter('dec2bool', ['$filter', function ($filter) {
    return function (value, fnParser) {
        value = $filter('decstr64')(value);
        return (/^(true|1)$/i).test(value);
    };
}]); // decode string then convert to boolean

app.filter('dec2obj', ['$filter', function ($filter) {
    return function (value) {
        value = $filter('decstr64')(value);
        return JSON.parse(value);
    };
}]); // decode string then convert to object

app.filter('sessKey', ['$filter', function ($filter) {
    // TODO refactor
    return function (n) {
        var RandomGeneratedNumber = [];
        RandomGeneratedNumber.length = 0;
        var favorite = '';
        var NumbersInArray = n;
        var RandomNumbers = n;
        var charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (var x = 0; x < NumbersInArray; x++) {
            var randomString = '';
            for (var i = 0; i < RandomNumbers; i++) {
                var randomPoz = Math.floor(Math.random() * charSet.length);
                randomString += charSet.substring(randomPoz, randomPoz + 1);
            }
            RandomGeneratedNumber.push(randomString);
        }
        favorite = RandomGeneratedNumber[Math.floor(Math.random() * RandomGeneratedNumber.length)];
        for (var y = 0; y <= RandomGeneratedNumber.length; y++) {
            if (RandomGeneratedNumber[y] == favorite) { }
        }
        //RandomChar = favorite;
        //return RandomChar;

        return favorite;
    };

}]); //end gen sess key filter

app.filter('EMdate', ['$filter', function ($filter) {
    return function (value) {
        if (!value || value.trim() === '') {
            return 'N/A'
        }
        
        return $filter('date')(value, 'dd/MM/yyyy');
    };
}]); // 'N/A' if null or no data, else convert to date format dd/MM/yyyy

app.filter('boolConverter', function() {
    return function (value) {
        return (/^(true|1)$/i).test(value);
    };
});

app.filter('trustedHtml', function($sce){
    return function(html){
        return $sce.trustAsHtml(html)
    }
 })